import _ from 'lodash'

export const CREDIT_CARDS = {
  AMEX: {
    className: 'amex',
    displayName: 'American Express',
    id: 'americanexpress',
    startNumbers: ['34', '37'],
  },
  VISA: {
    className: 'visa',
    displayName: 'Visa',
    id: 'visa',
    startNumbers: ['1', '4'],
  },
  MASTERCARD: {
    className: 'mc',
    displayName: 'Mastercard',
    id: 'mastercard',
    startNumbers: ['51', '52', '53', '54', '55'],
  },
  DISCOVER: {
    className: 'discover',
    displayName: 'Discover',
    id: 'discover',
    startNumbers: ['6'],
  },
}

const startsWith = (prefixes, string) => {
  return _.some(prefixes, prefix => _.startsWith(string, prefix))
}

export const getCCType = ccNumber => {
  const filtered = ccNumber.replace(/[^0-9]/g, '')
  if (!filtered) return null
  if (!_.toNumber(filtered)) return null
  return (
    _.find(CREDIT_CARDS, type => {
      return startsWith(type.startNumbers, filtered)
    }) || null
  )
}

export const getCCFromServerName = serverName => {
  const id = serverName.replace(/\s/g, '').toLowerCase()
  return _.find(CREDIT_CARDS, { id }) || null
}
